import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type BadgeTemplatesQueryVariables = Types.Exact<{
  input: Types.PaginatedBadgesInput;
}>;


export type BadgeTemplatesQuery = { badges: { success: boolean, totalCount: number, errorCode?: Types.PaginationErrorCodeEnum | null, pageInfo?: { endCursor?: string | null, hasNextPage?: boolean | null } | null, edges?: Array<{ node: { id: string, name: string, type?: Types.BadgeTypeEnum | null, description?: string | null, media?: { url?: string | null, name: string } | null } }> | null } };


export const BadgeTemplatesDocument = /*#__PURE__*/ gql`
    query badgeTemplates($input: PaginatedBadgesInput!) {
  badges(input: $input) {
    success
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    errorCode
    edges {
      node {
        id
        name
        type
        media {
          url
          name
        }
        description
      }
    }
  }
}
    `;

export function useBadgeTemplatesQuery(options: Omit<Urql.UseQueryArgs<BadgeTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<BadgeTemplatesQuery, BadgeTemplatesQueryVariables>({ query: BadgeTemplatesDocument, ...options });
};